import { defineStore } from 'pinia'

export const usePaymentsStore = defineStore('payments', {
    state: () => ({
        showingCardForm: false, // for payments on invoices
		showingSaveCardForm: false, // for saving payment methods
		cardable_id: null,
		cardable_type: null,
		invoice: null,
		savedCards: [],
		selectedCard: null,
		successCallback: null,
		infoComponent: null, // optional component to show in the save card form
    }),
    actions: {
		setCardable(type, id) {
			this.cardable_type = type
			this.cardable_id = id
		},
		showCardForm(invoice, cardable_type, cardable_id) {
			this.setCardable(cardable_type, cardable_id)
			this.showingCardForm = true
			this.invoice = invoice
			this.fetchSavedCards()
		},
		hideCardForm() {
			this.setCardable(null, null)
			this.showingCardForm = false
			this.invoice = null
		},
		showSaveCardForm(cardable_type, cardable_id, infoComponent = null) {
			this.setCardable(cardable_type, cardable_id)
			this.showingSaveCardForm = true
			this.infoComponent = infoComponent
		},
		hideSaveCardForm() {
			this.showingSaveCardForm = false
		},
		fetchSavedCards() {
			this.clearSavedCards()
			this.clearSelectedCard()
			if( !this.cardable_id || !this.cardable_type ) {
				throw "cannot fetch cards without cardable_id and cardable_type"
			}
			return axios.get('/api/cards', {
				params: {
					cardable_id: this.cardable_id,
					cardable_type: this.cardable_type
				}
			}).then(response => {
				this.savedCards = response.data
				// if we have a card with an auto_for field, select it (it is our automatic payment methods card)
				this.selectedCard = this.savedCards.find(c => c.auto_for)
				// otherwise select the first card
				if( !this.selectedCard ) {
					this.selectedCard = this.savedCards[0]
				}
			})
		},
		clearSavedCards() {
			this.savedCards = []
		},
		selectCard(card) {
			if( this.selectedCard == card ) {
				this.clearSelectedCard()
			} else {
				this.selectedCard = card
			}
		},
		clearSelectedCard() {
			this.selectedCard = null
		},
		deleteCard(card = null) {
			card = card || this.selectedCard
			if( !card ) {
				throw "cannot delete a card if there is none selected"
			}
			return axios.delete(`/api/cards/${card.id}`)
			// remove the card from our state on success
			.then(response => {
				this.savedCards = this.savedCards.filter(c => c.id != card.id)
			})
		},
		setAutomaticPaymentMethod(related_type = 'card', related_id = null) {
			related_id = related_id || this.selectedCard.id
			if( !related_id ) {
				throw "cannot set automatic payment method without a card"
			}
			if( !this.cardable_id || !this.cardable_type ) {
				throw "cannot set automatic payment method without cardable_id and cardable_type"
			}
			return axios.post('/organisations/' + this.cardable_id + '/payments/auto', {
				automatic_payment_method_type: related_type,
				automatic_payment_method_id: related_id
			})
		},
		setSuccessCallback(callback) {
			this.successCallback = callback
		},
		clearSuccessCallback() {
			this.successCallback = null
		},
		runSuccessCallback() {
			if( this.successCallback ) {
				this.successCallback()
			}
			this.clearSuccessCallback()
		}
    }
})
